import classNames from 'classnames';
import React, { useEffect, useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './style.module.scss';
import { PlusIcon, ProjectNameIcon, StatusCheckIcon, EyeIcon, DownloadIcon } from 'assets';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import LayoutPo from './LayoutPo';
import GenericTable from 'shared/components/common/table/table';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import Heading from 'shared/components/common/heading/Heading';
import Switch2 from 'shared/components/common/switch2/Switch2';
import CustomButton from 'shared/components/common/custom_button/CustomButton';
import AddClient from 'shared/modal/add_product/AddProduct';
import PurchaseOrderModal from 'shared/modal/purchase_order/PurchaseOrder';
import OverlayLoading from 'shared/screen_loader/overlay_loader/OverlayLoading';
import { GetAllPOQuery } from 'shared/services/po_service/POService';
import moment from 'moment';
import { isRestrictActions } from 'shared/utils/Helper';
import { screenActionEnum, screenEnum } from 'shared/utils/Enum';
import { routeConstant } from 'shared/routes/RouteConstant';
import ExcelExport from 'shared/components/common/ExcelExport/ExcelExport';
import SearchBar from 'shared/components/common/searchbar/SearchBar';
import PoSearchBar from 'shared/components/common/searchbar/PoSearchBar';
import { wareHouse } from 'shared/utils/Enum';
import Select from 'react-select';
import { GetAllWarehouse } from 'shared/services/ware_house_service/WareHouseService';



const IGNORED_KEYS = new Set(['_id', '__v', 'createdAt', 'updatedAt', 'created_at', 'updated_at', 'po']);

const deepSearchSingleWord = (obj, word) => {
    if (typeof obj === 'string' || typeof obj === 'number') {
        return obj.toString().toLowerCase().includes(word);
    }

    if (Array.isArray(obj)) {
        return obj.some(item => deepSearchSingleWord(item, word));
    }

    if (typeof obj === 'object' && obj !== null) {
        return Object.entries(obj).some(([key, value]) => {
            if (IGNORED_KEYS.has(key)) {
                return false;
            }
            return deepSearchSingleWord(value, word);
        });
    }

    return false;
};

const deepSearch = (obj, searchTerm) => {
    if (!searchTerm) return true;
    
    // Parse search terms supporting quoted phrases
    const regex = /"([^"]+)"|'([^']+)'|(\S+)/g;
    const words = [];
    let match;
    while ((match = regex.exec(searchTerm)) !== null) {
        const token = match[1] || match[2] || match[3];
        if (token) {
            words.push(token.toLowerCase());
        }
    }

    if (words.length === 0) return true;
    return words.every(word => deepSearchSingleWord(obj, word));
};

export default function PurchaseOrder() {
    const {
        theme: { theme }
    } = useSelector((state) => state.root);
    const [searchMenu, setsearchMenu] = useState('');
    const [clicksearch, setClickSearch] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [wareHouses, setWareHouses] = useState([]);
    const [selectedWarehouse, setSelectedWarehouse] = useState();

    const obj = {};
    if (clicksearch) {
        obj['search'] = clicksearch;
    }
    const queryObj = {};
    if (selectedWarehouse?.value) queryObj.warehouseId = selectedWarehouse.value;
    const queryString = new URLSearchParams(queryObj).toString();

    const { isLoading, data: PoList, isError, error, isSuccess } = GetAllPOQuery(queryString);
    const { data: listWareHouse } = GetAllWarehouse();

    console.log(listWareHouse, "selectedWarehouse");


    const SearchBars = (customSearchTerm) => {
        const term = customSearchTerm !== undefined ? customSearchTerm : searchMenu;
        if (term.length > 0) {
            const filteredData = PoList.filter((item) => deepSearch(item, term));
            setSearchResults(filteredData);
        } else {
            setSearchResults(PoList);
        }
    };
    useEffect(() => {
        const wareHouseoptions = (listWareHouse || []).map((w) => ({
            ...w,
            label: w?.code,
            value: w?._id,
        }));
        setWareHouses(wareHouseoptions);

        if (!isSuccess || !PoList) return;
        // handle data array (safe check)
        const poArray = Array.isArray(PoList)
            ? PoList
            : Array.isArray(PoList.data)
                ? PoList.data
                : [];

        // har PO me amount calculate krna
        poArray.forEach(po => {
            const totalAmount = (po.order || []).reduce((acc, order) => {
                const price = Number(order.price) || 0;
                const qty = Number(order.quantity) || 0;
                return acc + price * qty;
            }, 0);

            po.amount = totalAmount; // 🔥 direct add to object
        });

        // agar PoList nested structure me ho (PoList.data)
        if (PoList.data) {
            PoList.data = poArray;
        }

        console.log("✅ Updated PoList with amount:", PoList);
    }, [PoList, isSuccess]);

    const navigate = useNavigate();
    const [showModal, setShowModal] = useState(false);
    const [openProduct, setOpenProduct] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const pdfContainerRef = useRef(null);
    const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);

    // Download format selection states
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [selectedPO, setSelectedPO] = useState(null);

    const handleDownloadIconClick = (poData) => {
        setSelectedPO(poData);
        setShowDownloadModal(true);
    };

    const handleDownloadExcel = () => {
        if (!selectedPO) return;
        const poData = selectedPO;
        
        const dataForExcel = poData.order.map(item => ({
            "Brand": item.brand?.name || '',
            "Compatible Brand": item.compatiableBrand?.name || '',
            "Category": item.product_category?.name || '',
            "Sub Category": item.sub_category?.name || '',
            "Model": item.product?.name || item.product?.model || '',
            "Color": item.color || '',
            "Quantity": item.quantity || 0,
            "Price": item.price || 0,
            "Total": (item.quantity || 0) * (item.price || 0)
        }));

        const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "PO Items");
        XLSX.writeFile(workbook, `PO_${poData.order_number || poData._id}.xlsx`);

        setShowDownloadModal(false);
    };

    const handleDownloadPDF = async () => {
        if (!selectedPO || !pdfContainerRef.current) return;
        setIsGeneratingPdf(true);
        try {
            const elementToCapture = pdfContainerRef.current;
            const canvas = await html2canvas(elementToCapture, { scale: 2, useCORS: true });
            const imgData = canvas.toDataURL('image/png');
            
            const pdf = new jsPDF('p', 'mm', 'a4');
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
            
            pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
            pdf.save(`PO_${selectedPO.order_number || selectedPO._id}.pdf`);
        } catch (err) {
            console.error("Error generating PDF", err);
        } finally {
            setIsGeneratingPdf(false);
            setShowDownloadModal(false);
        }
    };

    const toggleEditUser = () => {
        setIsEdit(!isEdit);
    };
    useEffect(() => {
        if (PoList) {
            setSearchResults(PoList);
        }
    }, [PoList]);
    const navigateToPath = () => {
        navigate(routeConstant.admin.po.addpo.path);
    };
    const views = (data) => {
        navigate(routeConstant.admin.po.viewpo.path, { state: { data } });
    };
    const closeProductHandler = () => setOpenProduct(false);
    const formatPrice = (price) => {
        const num = Number(price);
        if (isNaN(num)) return 'Rs 0.00';
        return `${num.toFixed(2)}`;
    };

    const columns = React.useMemo(
        () => [
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Order#
                    </div>
                ),
                accessor: 'order_number',
                Cell: ({ row }) => <div>{row.original?.order_number}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Issue Date
                    </div>
                ),
                accessor: 'created_at',
                Cell: ({ row }) => <div>{moment(row.original?.created_at || row.original?.date).format('DD, MMM YYYY')}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Supplier
                    </div>
                ),
                accessor: 'supplier',
                Cell: ({ row }) => <div>{row.original?.supplier?.name}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <ProjectNameIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Total Amout
                    </div>
                ),
                accessor: 'amount',
                Cell: ({ row }) => <div>{formatPrice(row.original?.amount)}</div>
            },
            {
                Header: (
                    <div className={classNames(`${theme}FontColor`)}>
                        <StatusCheckIcon className={classNames(styles.TableHeadingIcon, `${theme}SvgIcon`)} style={{ marginRight: '6px' }} />
                        Action
                    </div>
                ),
                accessor: 'view&print',
                Cell: ({ row }) => (
                    <div className="d-flex align-items-center gap-3">
                        <EyeIcon onClick={() => views(row?.original)} style={{ cursor: 'pointer' }} title="View PO" />
                        <DownloadIcon onClick={() => handleDownloadIconClick(row?.original)} style={{ cursor: 'pointer', width: '20px', height: '20px' }} title="Download PO" className={`${theme}SvgIcon`} />
                    </div>
                )
            }
        ],

        [theme, showModal]
    );
    console.log(PoList, "polist");

    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <PoSearchBar setsearchMenu={setsearchMenu} searchMenu={searchMenu} suggestionsSource={PoList} SearchBars={SearchBars} />
                <div className={styles.Header}>
                    <Heading heading={'Purchase Order'} headingStyle={styles.Heading} />
                    <div className={styles.HeaderActions}>
                        <Select
                            placeholder="Filter by Warehouse"
                            isClearable
                            options={wareHouses}
                            value={selectedWarehouse}
                            menuPortalTarget={document.body}
                            styles={{
                                control: (provided) => ({
                                    ...provided,
                                    minWidth: 220,
                                    height: '40px',
                                    minHeight: '40px',
                                    borderRadius: '6px',
                                }),
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            onChange={(item) => setSelectedWarehouse(item)}
                        />
                        <CustomButton
                            Icon={PlusIcon}
                            submitHandle={() => {
                                if (isRestrictActions(screenEnum.po, screenActionEnum.create)) {
                                    navigateToPath();
                                }
                            }}
                            IconStyle={classNames('me-1', styles.IconStyle)}
                            text={'Purchase Order'}
                            containerStyle={classNames(styles.AddProduct)}
                        />
                        <ExcelExport data={PoList} fileName={'Purchase Order'} />
                    </div>
                </div>
                <GenericTable columns={columns} data={searchResults || []} TableWrapperStyle={classNames(styles.Table)} />
                <AddClient show={openProduct} handleClose={closeProductHandler} />
            </div>
            {isLoading && <OverlayLoading />}
            {isGeneratingPdf && <OverlayLoading />}

            {/* Hidden container to perfectly render LayoutPo for PDF generation */}
            <div style={{ position: 'absolute', top: '-10000px', left: '-10000px', opacity: 0, pointerEvents: 'none' }}>
                <div ref={pdfContainerRef} style={{ width: '1000px', padding: '20px', backgroundColor: 'white' }}>
                    {selectedPO && <LayoutPo poDataProp={selectedPO} hidePrintButton={true} />}
                </div>
            </div>

            <Modal show={showDownloadModal} onHide={() => setShowDownloadModal(false)} centered size="sm">
                <Modal.Header closeButton className={classNames(styles.Header, `${theme}ModalBackground`)} style={{ borderBottom: 'none' }}>
                    <Heading heading={'Download Format'} headingStyle={styles.ModalHeading} />
                </Modal.Header>
                <Modal.Body className={classNames(`${theme}ModalBackground`, 'text-center py-4')}>
                    <p className="mb-4 text-muted" style={{ fontSize: '14px' }}>Select the format you want to download</p>
                    <div className="d-flex justify-content-center gap-3">
                        <CustomButton
                            text={'Excel (.xlsx)'}
                            containerStyle={styles.DownloadBtnExcel}
                            submitHandle={handleDownloadExcel}
                        />
                        <button 
                            className={classNames('btn btn-danger d-flex align-items-center justify-content-center', styles.DownloadBtnPdf)} 
                            onClick={handleDownloadPDF}
                            disabled={isGeneratingPdf}
                        >
                            {isGeneratingPdf ? 'Processing...' : 'PDF (.pdf)'}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </DashboardWrapper>
    );
}
